import React from 'react';

// Styles
import './AccountSidebar.scss';

// Comps
import DropdownMenu from '@src/stories/blocks/DropdownMenu/DropdownMenu';

const AccountSidebar = ({ menu, colorSchema }) => {
  return (
    <div className='account-sidebar'>
      <DropdownMenu
        links={menu}
        colorSchema={colorSchema}
        hoverAnimation={true}
        disableDesktop={true}
        breakpoint={768}
      />
    </div>
  );
};

export default AccountSidebar;
